import { Controller } from 'front-end-core/core/Router'
import getUrl from 'front-end-core/core/url'
import { QA_MENU } from 'constants/controllers'
import Header from './Header'
import Main from 'redux/containers/pages/qamenu/QAMenuContainer'

export default new Controller({
  name: QA_MENU,
  route: ':aol/:flavour/qa',
  controller (
    Router,
    {
      url: pageId,
      scrollMain,
      pageView,
      pageData = {},
      pageState = {},
      previousPageId,
      params: { aol, flavour }
    },
    render
  ) {
    render(
      { Main, Header },
      { flavour },
      {
        bottleLink: flavour => getUrl(QA_MENU, { aol, flavour }),
        aol,
        flavour,
        pageId,
        pageView,
        searchType: 'qa'
      }
    )

    return pageId
  }
})
